import P from 'prop-types';
import UniversalContainer from '../universal-container';
import styles from './grid.module.less';
import ItemComponents from './grid-item-component';

const GridItems = ({
  items,
  disableDefaultProps,
  isBuilderPage,
  outputGridItemIndicator,
  outputDashedBorder,
}) => {
  const itemContainerConfig = (item) => ({
    ...item?.itemContainer,
    alignment: {
      ...item?.itemContainer?.alignment,
      type: 'flex',
    },
  });

  return items.map((item, index) => (
    <UniversalContainer
      {...itemContainerConfig(item)}
      style={{ position: 'relative' }}
    >
      {outputGridItemIndicator && (
        <span data-testid="grid-indicator" className={styles.gridItemIndicator}>
          {index + 1}
        </span>
      )}
      <ItemComponents
        key={item.$unique_key}
        components={item?.itemComponents}
        disableDefaultProps={disableDefaultProps}
        isBuilderPage={isBuilderPage}
        outputDashedBorder={outputDashedBorder}
      />
    </UniversalContainer>
  ));
};

GridItems.propTypes = {
  items: P.array,
  disableDefaultProps: P.bool,
  isBuilderPage: P.bool,
  outputGridItemIndicator: P.bool,
  outputDashedBorder: P.bool,
};

GridItems.defaultProps = {
  items: [],
};

ItemComponents.propTypes = {
  components: P.array,
  outputDashedBorder: P.bool,
};

export default GridItems;
